import cn from 'classnames';
import styles from './index.module.css';

function InputField({ className, onChange, ...props }) {
  return (
    <input
      className={cn({
        [styles.inputField]: true,
        [className]: className,
      })}
      onChange={(e) => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
      {...props}
    />
  );
}

export default InputField;
